import { useEffect, useRef } from "react";

export function useSpaceClick(enabled: boolean, tab: string, doClickRef: React.MutableRefObject<(cx: number, cy: number) => void>): void {
  const spaceHeldRef = useRef(false);
  useEffect(() => {
    if (!enabled) return;
    if (tab !== "bake") return;
    const isSpace = (e: KeyboardEvent): boolean => {
      if (e.code === "Space") return true;
      return e.key === " " || e.key === "Spacebar";
    };
    const inEditable = (t: EventTarget | null): boolean => {
      if (!(t instanceof HTMLElement)) return false;
      const tag = t.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
      if (t.isContentEditable) return true;
      return false;
    };
    const onDown = (e: KeyboardEvent): void => {
      if (!isSpace(e)) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (inEditable(e.target)) return;
      e.preventDefault();
      try {
        if (typeof (e as unknown as { stopPropagation?: () => void }).stopPropagation === "function") {
          (e as unknown as { stopPropagation: () => void }).stopPropagation();
        }
      } catch {
        return;
      }
      if (e.repeat || spaceHeldRef.current) return;
      spaceHeldRef.current = true;
      doClickRef.current(0.5, 0.52);
    };
    const onUp = (e: KeyboardEvent): void => {
      if (!isSpace(e)) return;
      try {
        e.preventDefault();
      } catch {
        return;
      }
      spaceHeldRef.current = false;
    };
    const onBlur = (): void => {
      spaceHeldRef.current = false;
    };
    window.addEventListener("keydown", onDown, true);
    window.addEventListener("keyup", onUp, true);
    window.addEventListener("blur", onBlur);
    return () => {
      window.removeEventListener("keydown", onDown, true);
      window.removeEventListener("keyup", onUp, true);
      window.removeEventListener("blur", onBlur);
      spaceHeldRef.current = false;
    };
  }, [enabled, tab, doClickRef]);
}
